import React, { useEffect, useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../Components/buttton";
import Footer from "../Components/Footer";
import { LoginUser } from "../NetworkCalls/Products/ServerReq";
import { apiUrl } from "../axios";
import axios from "axios";
import { checkAuth } from "../utils/auth";

const Login = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [Error, setError] = useState("");
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [passwordTyping, setPasswordTyping] = useState(false);

  useEffect(() => {
    // Redirect to dashboard if already logged in
    if (checkAuth()) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "password") {
      setPasswordTyping(true);
    }
    if (value === "") {
      setPasswordTyping(false);
    }
    setData((preValue) => ({
      ...preValue,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoader(true);
    setError("");
    try {
      const response = await axios.post(`${apiUrl}user/loginAdmin`, data);
      if (response?.data?.success) {
        const user = {
          userId: response.data.data.userId,
          token: response?.data.data.token,
          userName: response?.data.data.userName,
        };
        localStorage.setItem("info", JSON.stringify(user));
        navigate("/dashboard");
      }
    } catch (error) {
      if (error?.response?.data?.response?.message) {
        setError(error?.response?.data?.response?.message);
      } else {
        setError("Internal Server Error");
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {/* {Error && <div>{Error}</div>} */}

      <div
        className="main_container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: "#F5F6FA",
          alignItems: "center",
          position: "relative",
        }}
      >
        <img
          src="/assets/login__logo.svg"
          alt="logo"
          style={{
            width: "200px",
            marginBottom: "15px",
            marginTop: "-40px",
          }}
        />
        <div className="login_container">
          <div
            style={{
              margin: "40px 30px 20px 30px",
              width: "100%",
              textAlign: "center",
            }}
          >
            <h1
            style={{fontFamily: "Urbanist"}}
            >
              Admin Panel
            </h1>
            <h3
              style={{
                fontFamily: "Urbanist",
                color: "#181C23",
                fontWeight: "500",
                fontSize: "18px",
              }}
            >
              Login in with your credentials
            </h3>
          </div>
          <form onSubmit={handleSubmit} style={{ width: "90%" }}>
            <div className="textfields_div">
              <p
                style={{
                  color: "#181C23",
                  fontWeight: "bold",
                }}
              >
                Email
              </p>

              <input
                style={{
                  width: "100%",
                  padding: "12px 0",
                  borderBottom: "1px solid #757B85",
                  outline: "none",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  fontFamily: "Urbanist",
                }}
                type="email"
                required
                name="email"
                value={data.email}
                placeholder="Enter your email address"
                onChange={handleChange}
              />
            </div>

            <div className="textfields_div">
              <p
                style={{
                  color: "#181C23",
                  fontWeight: "bold",
                }}
              >
                Password
              </p>

              <input
                style={{
                  width: "100%",
                  padding: "12px 0",
                  borderBottom: "1px solid #757B85",
                  outline: "none",
                  fontFamily: passwordTyping ? "auto" : "Urbanist",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                }}
                type="password"
                required
                placeholder="Enter your password"
                name="password"
                value={data.password}
                onChange={handleChange}
              />
            </div>

            <div>
              <ButtonComponent loader={loader} name="Submit" type="submit" />
              <div
                style={{
                  color: "#E12F2F",
                  fontWeight: 500,
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                {Error}
              </div>
            </div>
          </form>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Login;
